import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "icon"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { IconMore } from '../Icon/index';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden';
import { StyledDropdownIcon } from './DropdownIcon.styles';

/**
 * The default variant for `DropdownPopper`.
 *
 * @related [`Dropdown`]
 * @since 7.28.0
 */
export var DropdownIcon = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledDropdownIcon, _extends({}, rest, {
    ref: forwardedRef
  }), icon, children);
});
DropdownIcon.displayName = 'DropdownIcon';
DropdownIcon.propTypes = {
  /**
   * You can use the children prop to provide a
   * `VisuallyHidden` label.
   */
  children: PropTypes.node,
  /**
   * The `Icon` used as a trigger.
   */
  icon: PropTypes.node
};
DropdownIcon.defaultProps = {
  children: /*#__PURE__*/React.createElement(VisuallyHidden, null, "Show more"),
  icon: /*#__PURE__*/React.createElement(IconMore, null)
};